module.exports = __webpack_public_path__ + "img/OEHU_HOME.ebae5407.svg";